<template>
  <div id="app">
    <label-nav></label-nav>
    <router-view></router-view>
    <label-footer></label-footer>
  </div>
</template>

<script>
  import labelFooter from 'components/Footer';
  import labelNav from 'components/Nav';

  export default {
    name:       'app',
    components: { labelFooter, labelNav },
  };
</script>

<style lang="scss">
  $icon-font-path: "../node_modules/bootstrap-sass/assets/fonts/bootstrap/";

  @import "../node_modules/bootstrap-sass/assets/stylesheets/_bootstrap.scss";

  body {
    font-family: 'Roboto Condensed', sans-serif;
  }

  a {
    color: #638E9C;
  }

  .full-header {
    position: relative;
    height: 100vh;
    background-color: #F8F8F8;
  }

  .full-header h1 {
    font-size: 50px;
  }

  .full-header .inner {
    width: 100%;
    position: absolute;
    display: block;
    margin: 0 auto;
    top: 50%;
    transform: translateY(-50%);
  }

  .intro-text {
    margin-top: 40px;
  }

  .full-header .logo {
    height: 150px;
    width: 150px;
    background: url("~assets/images/logo.svg") no-repeat center;
    margin: 0 auto;
    background-size: cover;
  }

  .full-header .intro-text {
    text-align: center;
    color: #638E9C;
  }

  @media (max-width: 992px) {
    .full-header {
      padding-top: 50px;
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?dfd2fe0a